import { create } from 'zustand';

// A ROOM'S RECORDED GREETING (components/RoomGreeting, 2026-11-01): which room's
// desk is speaking right now (FrontDesk turns on the speaking face), and which
// desks have their person loaded — the shot waits for her to be there.
export const useGreeting = create((set) => ({
  talking: null,          // roomId whose desk is speaking, or null
  deskReady: {},          // { [roomId]: true } once the desk's body has loaded
  setTalking: (talking) => set({ talking }),
  markDeskReady: (roomId) => set((s) => (s.deskReady[roomId] ? s : { deskReady: { ...s.deskReady, [roomId]: true } })),
}));
